import { BydValidationInterface } from '../interfaces/byd-validation.interface';

export class BydValidation {
  /**
   * Description.
   */
  public label: string;

  /**
   * Color.
   */
  public color: string;

  /**
   * IsExpired.
   */
  public isExpired: boolean;

  /**
   * Comment.
   */
  public comment: string;

  /**
   * State Visa.
   */
  public stateVisa: string;

  /**
   * ResponseDate.
   */
  public responseDate: Date | null;

  /**
   * State Visa.
   */
  public dueDate: number;

  /**
   * Validator.
   */
  public validator: string;

  /**
   * Number of late days.
   */
  public nbOfDays: number;

  /**
   * Attachment.
   */
  attachment: string;

  /**
   * @param data Data.
   */
  constructor(data: BydValidationInterface) {
    if (data) {
      this.label = data.label;
      this.color = data.color;
      this.isExpired = data.isExpired;
      this.comment = data.comment;
      this.stateVisa = data.stateVisa;
      this.responseDate = data.responseDate;
      this.dueDate = data.dueDate;
      this.validator = data.validator;
      if (data.nbOfDays) this.nbOfDays = data.nbOfDays;
      this.attachment = data.attachment;
    }
  }
}
